import React, { useEffect, useState } from "react";
import { HoroscopeListContainer } from "./style";

export const HoroscopePredictions = ({ signo, prediction=[], isTomorrow }) => {
  const [formattedPredictions, setFormattedPredictions] = useState([]);

  useEffect(() => {
    if (Array.isArray(prediction)) {
      const formattedPredictionsList = prediction.map((element) => {
        const { formattedDate, weekday } = formatDate(element.date);
        const dat = new Date();
        if (isTomorrow) {
          dat.setDate(dat.getDate() + 2);
        }
        const year = dat.getFullYear();
        const month = (dat.getMonth() + 1).toString().padStart(2, "0");
        const day = dat.getDate().toString().padStart(2, "0");
        const fotmatDat = `${year}${month}${day}`;
        const formaToday = `${year}${month}${day}`;
        let descripcionHoy;
        if (isTomorrow) {
          descripcionHoy =
            fotmatDat <= element.date &&
            element.signos
              .flatMap((signo) => signo.data)
              .find((data) => data.nombre === "Hoy")?.descripcion;
        } else {
          descripcionHoy =
            formattedDate === todayFormatted
              ? null
              : formaToday < element.date &&
                element.signos
                  .flatMap((signo) => signo.data)
                  .find((data) => data.nombre === "Hoy")?.descripcion;
        }
        return {
          fecha: weekday,
          descripcion: descripcionHoy,
        };
      });
      setFormattedPredictions(formattedPredictionsList);
    }
  }, [prediction, isTomorrow]);

  const formatDate = (dateString) => {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    const formattedDate = new Date(`${year}-${month}-${day}`);
    formattedDate.setDate(formattedDate.getDate() + 1);
    const options = { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" };
    const date = formattedDate.toLocaleDateString("es-ES", options);
    const weekday = date.charAt(0).toUpperCase() + date.slice(1);
    return { formattedDate, weekday };
  };

  const today = new Date();
  const options = { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" };
  const todayFormatted = today.toLocaleDateString("es-ES", options);

  return (
    signo &&
    <HoroscopeListContainer>
      <div className="horoscope-predictions-list-header">
        <h2 className="horoscope-predictions-list-header-text">Próximas Predicciones {signo}</h2>
      </div>
      <div className="horoscope-predictions-list-signs-container">
        {formattedPredictions.length > 0 &&
          formattedPredictions.map((item, index) => (
            item.descripcion &&
            <div className="horoscope-predictions-list-item" key={`prediction-${index}`}>
              <h3 className="horoscope-predictions-list-item-date">{item.fecha}</h3>
              <p className="horoscope-predictions-list-item-text">{item.descripcion}</p>
            </div>
          ))}
      </div>
    </HoroscopeListContainer>
  );
};
